import React from 'react';
import PropTypes from 'prop-types';
import {LabelColumn} from '../LabelColumn';
import {COL_TYPE} from '../GelDragDrop.constants';
import {checkIfTrashMessageBright, getStyle} from './Table.utils';
import {GelDragDropContext, GelTableRef} from '../GelDragDrop.utils';
import {LadderColumn} from '../LadderColumn';
import {BandColumn} from '../BandColumn';

export function Table(props) {
  const {calculateHeight} = React.useContext(GelDragDropContext);

  React.useEffect(() => calculateHeight(GelTableRef.current), []);

  const isTrashMessageBright = React.useMemo(
    () => checkIfTrashMessageBright(props.table),
    [props.table]
  );

  const getClassName = (type) => {
    return `gelDragDrop_table__${type.toLowerCase()}`;
  };

  const renderColumn = (column) => {
    switch (column.colType) {
      case COL_TYPE.LABEL_COLUMN:
        return (
          <LabelColumn
            key={column.colId}
            colId={column.colId}
            colItems={column.colItems}
            className={getClassName(column.colType)}
            isBright={isTrashMessageBright}
          />
        );
      case COL_TYPE.LADDER_COLUMN:
        return (
          <LadderColumn
            key={column.colId}
            colId={column.colId}
            colItems={column.colItems}
            className={getClassName(column.colType)}
          />
        );
      case COL_TYPE.BAND_COLUMN:
        return (
          <BandColumn
            useAbbrevLabel={props.useAbbrevLabel}
            key={column.colId}
            colId={column.colId}
            colItems={column.colItems}
            className={getClassName(column.colType)}
          />
        );
      default:
        return null;
    }
  };

  const style = React.useMemo(() => getStyle(props.table), [
    props.table.length,
  ]);

  return (
    <div className='gelDragDrop_table' style={style} ref={GelTableRef}>
      {props.table.map(renderColumn)}
    </div>
  );
}

Table.propTypes = {
  /**
   * Data for gel Table
   */
  table: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * Unqiue id for the column
       */
      colId: PropTypes.number,
      /**
       * Type of column
       */
      colType: PropTypes.oneOf(Object.keys(COL_TYPE)),
      /**
       * Items in a column
       */
      colItems: PropTypes.arrayOf(PropTypes.object),
    })
  ),
};

Table.defaultProps = {};
